import React from 'react'
// import styles from './PrintOfficialPDFModal.scss'
import {ConfirmationDialog} from 'common/styleguide/ConfirmationDialog'

export const PRINT_OFFICIAL_PDF_MODAL = 'PRINT_OFFICIAL_PDF_MODAL'

export class PrintOfficialPDFModal extends React.PureComponent {
  downloadOfficialPDF = () => {
    const {troute} = this.props
    window.open(troute.officialMapPdfUrl)
  }

  customizePDF = () => {
    const {troute, objectType, onRequestClose} = this.props
    const printURL = `/${objectType}s/${troute.id}/print`
    window.open(printURL)
    onRequestClose()
  }

  render () {
    const {onRequestClose} = this.props
    return (
      <ConfirmationDialog
        onRequestClose={onRequestClose}
        cancelText='Customize PDF'
        onCancel={this.customizePDF}
        confirmText='Print Official'
        onConfirm={this.downloadOfficialPDF}>
        This route has an Official PDF provided by its author. You can print the Official PDF or change the settings to customize your map and cue sheet.
      </ConfirmationDialog>
    )
  }
}
